import { styled } from '@mui/material/styles';

export const StyledFormLabel = styled('div')(() => ({
  flex: 1,
  fontWeight: 'bold',
  width: '100%',
  wordBreak: 'normal',
  paddingBottom: '0px !important',
}));

export const StyledFormValue = styled('div')(() => ({
  flex: 1,
  display: 'flex',
  width: '100%',
  wordBreak: 'normal',
  paddingRight: '5px',
}));